import React from 'react';
import Particle from "../Particle";
import { Container, Row, Col } from "react-bootstrap";
import BlogCard from './BlogCard';
import specificity from '../../Images/Blog/specificity.JPG'
import scope from '../../Images/Blog/scope.JPG'
import string from '../../Images/Blog/string.JPG'
import react from '../../Images/Blog/react.JPG'

import {
    slideInRight,
    bounceIn,
    slideInLeft,
    slideInUp,
    slideInDown,
} from "react-animations";
import Radium, { StyleRoot } from "radium";



const Blogs = () => {
    const styles = {
        slideInLeft: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInLeft, "bounce"),
        },
        slideInUp: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInUp, "bounce"),
        },
        slideInRight: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInRight, "bounce"),
        },
        bounceIn: {
            animation: "x 3s",
            animationName: Radium.keyframes(bounceIn, "bounce"),
        },
        slideInDown: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInDown, "bounce"),
        },
    };
    return (
        <StyleRoot>
            <Container fluid className="project-section">
                <Particle />
                <Container>
                    <h1 className="project-heading" style={styles.slideInDown}>
                        <strong className="purple">    Blogs  </strong>
                    </h1>
                    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
                        <Col md={4} className="project-card">
                            <BlogCard
                                imgPath={specificity}
                                title="What the Heck Is CSS Specificity?"
                                link="https://medium.com/@nhnajmul17/what-the-heck-is-css-specificity-28d48e28af7"
                            >

                            </BlogCard>
                        </Col>
                        <Col md={4} className="project-card">
                            <BlogCard
                                imgPath={scope}
                                title="All you need to know about Javascript Scope."
                                link="https://medium.com/@nhnajmul17/all-you-need-to-know-about-javascript-scope-e10f54bca150">

                            </BlogCard>
                        </Col>
                        <Col md={4} className="project-card">
                            <BlogCard
                                imgPath={string}
                                title="String In JavaScript"
                                link="https://medium.com/@nhnajmul17/string-in-javascript-d0c9052f2c88">

                            </BlogCard>
                        </Col>
                        <Col md={4} className="project-card">
                            <BlogCard
                                imgPath={react}
                                title="Some Concepts About React Js."
                                link="https://medium.com/@nhnajmul17/some-concepts-about-react-js-6ef782cca0ab">

                            </BlogCard>
                        </Col>
                    </Row>

                </Container>
            </Container>
        </StyleRoot>
    );
};

export default Blogs;